import PageHeader from "../../../components/ui/page header/PageHeader";
import { useTranslation } from "react-i18next";
import PartnersSection from "./components/partnersSection/PartnersSection";

function PartnersPage() {
  const { t } = useTranslation("partners");

  return<>
    <PageHeader
      topic={t("pageHeader.topic")}
      topicSentence={t("pageHeader.topicSentence")}
    />
    <PartnersSection/>
  </>;
}

export default PartnersPage;
